var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wrapper"}},[_vm._m(0),(_vm.text)?_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-facebook"},[_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }